/*
  Inspired from
  https://github.com/JedWatson/exenv/blob/master/index.js
*/

export const isServer = typeof window === 'undefined'
export const isClient = !isServer
export const canUseDOM = !!(isClient && window.document && window.document.createElement)
export const canUseWorkers = typeof Worker !== 'undefined'
export const canUseEventListener = canUseDOM && !!(window.addEventListener || window.attachEvent)
export const canUseViewport = canUseDOM && !!window.screen
export default {
  isServer,
  isClient,
  canUseDOM,
  canUseWorkers,
  canUseEventListener,
  canUseViewport,
}
